// SemanticUI-free pre-@plone/components
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import { UniversalLink } from '@plone/volto/components';
import { toBackendLang } from '@plone/volto/helpers';
import BscLogo from '../../../../images/BSC.svg';
import RespireLogo from '../../../../images/respire-white.png';
import Logos2 from '../../../../images/logos.png';
import { flattenToAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  site: {
    id: 'Site',
    defaultMessage: 'Site',
  },
  homepage: {
    id: 'Back to homepage',
    defaultMessage: 'Back to homepage',
  },
});

const Logo = () => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);
  const intl = useIntl();
  const site = useSelector((state) => state.site.data);

  return (
    <main>
      <UniversalLink
        href={settings.isMultilingual ? `/${toBackendLang(lang)}` : '/'}
        title={intl.formatMessage(messages.site)}
      >
        <img
          src={
            site['plone.site_logo']
              ? flattenToAppURL(site['plone.site_logo'])
              : RespireLogo
          }
          width={300}
          alt={intl.formatMessage(messages.homepage)}
          title={intl.formatMessage(messages.homepage)}
        />
      </UniversalLink>
    </main>
  );
};

export default Logo;
